import { getZoneDetails } from '@atredux/selectors/zoneSelector'
import { store } from '@atredux/store'

export async function getZoneInfoListener () {
    console.log('ATBase: Received request for zone info.')

    return Promise.resolve(getZoneDetails(store.getState()))
}
